// LegalDocument.js
import React from 'react';
import PropTypes from 'prop-types';

export default function LegalDocument({ index, uploadedFiles, handleDrop, handleFileUpload }) {
  return (
    <div key={index}>
      <label
        htmlFor={`file-upload-${index}`}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        Upload File {index + 1}
      </label>
      <div
        className="flex flex-col items-center justify-center border border-gray-300 p-6 rounded-lg transition duration-300 hover:border-gray-400 bg-white shadow-lg hover:shadow-xl"
        onDrop={(e) => handleDrop(e, index)}
      >
        <div className="w-16 h-16 mb-4 flex items-center justify-center bg-gradient-to-br from-purple-400 to-indigo-500 rounded-full">
          <span className="text-white text-2xl">+</span>
        </div>
        <input
          id={`file-upload-${index}`}
          type="file"
          accept="file/image"
          onChange={(e) => handleFileUpload(e, index)}
          className="hidden"
        />
        <label
          htmlFor={`file-upload-${index}`}
          className="text-sm text-purple-600 cursor-pointer transition duration-300 hover:text-purple-700"
        >
          Choose File
        </label>
        <p className="mt-2 text-xs text-gray-500">or drag and drop</p>
        {/* Display selected file name */}
        {uploadedFiles[index] && (
          <p className="mt-2 text-xs text-gray-500 truncate">
            {uploadedFiles[index].name}
          </p>
        )}
      </div>
    </div>
  );
}

LegalDocument.propTypes = {
  index: PropTypes.number,
  uploadedFiles: PropTypes.func,
  handleDrop: PropTypes.func,
  handleFileUpload: PropTypes.func
}